import styles from './index.css'

const CardSectionTitle = props => {
  return (
    <h4 className={styles.title}>{props.children}</h4>
  )
}

export default CardSectionTitle
